<template>
  <div class="covid">
      <p class="covid__p">
        Donadora y Cumplo se unen para apoyar a microempresas
        mexicanas ante la lucha de la crisis económica consecuencia del
        COVID-19.
        <br>
        <a
          class="covid__link"
          href="https://donadora.org/cumploxmexico"
          target="_blank">
          <b>Conoce más de esta iniciativa</b>
        </a>
      </p>
    </div>
</template>

<script>
export default {
  name: 'CovidBanner'
}
</script>

<style lang="scss">

  .covid {
    background: $yellow;
    padding: 1em;
    text-align: center;
  }

  .covid__p {
  line-height: 2em;
  font-size: 1em;
  letter-spacing: .1em;
  margin: 0;
  padding: 0;
  color: $white;
}

.covid__link {
  color: $white;
  text-decoration: underline;
}

.covid__link:hover {
  color: #dedede;
}

</style>



// WEBPACK FOOTER //
// src/components/Navigation/CovidBanner/CovidBanner.vue